import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRegionStats, ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";
import {IPaginatedResponse} from "../../request/IResponse";
import {SEARCH_REGIONS_LIMIT} from "../../search/constants/search_regions";

const regionListApiLink = apiV2ListLink.region.list(Scenario.REGION_DETAIL);

interface IRegionsStatsPayload {
    regionsIds: number[];
}

interface IRegionsStatsResponse extends IPaginatedResponse {
    results: ISelectedRegion[];
}

type RegionStatsType = Pick<
    IRegionStats,
    | "properties_houses_ranges_price_max"
    | "properties_studios_ranges_price_max"
    | "properties_commercials_ranges_price_max"
    | "properties_flats_ranges_price_max"
>;

const configuratorApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getStats: builder.query<{maxPrice: number}, IRegionsStatsPayload>({
            query: (params) => {
                return {
                    url: regionListApiLink,
                    params: {
                        region: params.regionsIds,
                        page_size: SEARCH_REGIONS_LIMIT
                    },
                    method: "GET"
                };
            },
            transformResponse: (response) => {
                const res = response as IRegionsStatsResponse;
                const regionStats = res?.results?.map((region) => region.stats as RegionStatsType);
                const maxPrice = regionStats.reduce((acc, stats) => {
                    const maxRegionPrice = Math.max(
                        stats.properties_houses_ranges_price_max || 0,
                        stats.properties_flats_ranges_price_max || 0,
                        stats.properties_commercials_ranges_price_max || 0,
                        stats.properties_studios_ranges_price_max || 0
                    );
                    return maxRegionPrice > acc ? maxRegionPrice : acc;
                }, budgetFilterDefaults.totalMax);
                return {maxPrice};
            }
        })
    })
});

export const {useGetStatsQuery} = configuratorApi;
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRegionStats, ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";
import {IPaginatedResponse} from "../../request/IResponse";
import {SEARCH_REGIONS_LIMIT} from "../../search/constants/search_regions";

const regionListApiLink = apiV2ListLink.region.list(Scenario.REGION_DETAIL);

interface IRegionsStatsPayload {
    regionsIds: number[];
}

interface IRegionsStatsResponse extends IPaginatedResponse {
    results: ISelectedRegion[];
}

type RegionStatsType = Pick<
    IRegionStats,
    | "properties_houses_ranges_price_max"
    | "properties_studios_ranges_price_max"
    | "properties_commercials_ranges_price_max"
    | "properties_flats_ranges_price_max"
>;

const configuratorApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getStats: builder.query<{maxPrice: number}, IRegionsStatsPayload>({
            query: (params) => {
                return {
                    url: regionListApiLink,
                    params: {
                        region: params.regionsIds,
                        page_size: SEARCH_REGIONS_LIMIT
                    },
                    method: "GET"
                };
            },
            transformResponse: (response) => {
                const res = response as IRegionsStatsResponse;
                const regionStats = res?.results?.map((region) => region.stats as RegionStatsType);
                const maxPrice = regionStats.reduce((acc, stats) => {
                    const maxRegionPrice = Math.max(
                        stats.properties_houses_ranges_price_max || 0,
                        stats.properties_flats_ranges_price_max || 0,
                        stats.properties_commercials_ranges_price_max || 0,
                        stats.properties_studios_ranges_price_max || 0
                    );
                    return maxRegionPrice > acc ? maxRegionPrice : acc;
                }, budgetFilterDefaults.totalMax);
                return {maxPrice};
            }
        })
    })
});

export const {useGetStatsQuery} = configuratorApi;
